import React from "react"

import style from "./AvailableDeliverySlots.module.scss"

function AvailableDeliverySlots(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { slots, isTakeaway = false } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function uniqueBy(arr, fn) {
    let unique = {}
    let distinct = []
    arr.forEach(function (x) {
      const key = fn(x)

      if (!unique[key]) {
        distinct.push(x)
        unique[key] = true
      }
    })
    return distinct
  }

  function renderFirstSlot(slots, isTakeAway) {
    if (slots.length === 0) {
      return <b>{I18n.t("service_ordering.exausted_deliveries_for_today")}</b>
    }

    const firstSlot = uniqueBy(slots, function (x) {
      return x.start_time
    })[0]

    const { start_time, end_time, picking_times } = firstSlot

    if (isTakeAway) {
      const firstPickingTime = picking_times[0]

      return <span className={style.deliveryTime}>{firstPickingTime}</span>
    } else {
      return (
        <span
          className={style.deliveryTime}
        >{`${start_time}-${end_time}`}</span>
      )
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      <p className={`text-small ${style.paragraph}`}>
        <i className={`fal fa-alarm-clock mr-2 ${style.icon}`} />
        {isTakeaway
          ? I18n.t("service_ordering.first_pickup")
          : I18n.t("service_ordering.first_delivery")}

        {!slots && <i>{I18n.t("service_ordering.getting_delivery_times")}</i>}
        {!!slots && renderFirstSlot(slots, isTakeaway)}
      </p>
    </div>
  )
}

export default AvailableDeliverySlots
